import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';

export const office365TableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.office365.datasetType,
    displayName: __IS_FABRIC_DPE__ ? stringResources.Microsoft365_DisplayText : stringResources.Office365_DisplayText,
    datasetNamePrefix: 'Microsoft365Table',
    supportLinkedServiceTypes: [adfModelTypeMap.office365.linkedServiceType],
    notSupportLookupActivity: __IS_FABRIC_DPE__, // ADF doesn't support it officially. But given it is already there, let's keep it. 
    supportDataTypes: defaultSupportedColumnTypes.concat([ColumnType.Array, ColumnType.Object]),
    isSource: true,
    isSink: false,
    sourceSupportFlattenColumns: __IS_FABRIC_DPE__,
    notSupportTypeConversion: !__IS_FABRIC_DPE__,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-o365'
    },
    isFirstClass: true,
    notSupportPreviewData: !__IS_FABRIC_DPE__,
    notSupportCopySourceQuery: true,
    notSupportSchemaTypeEdit: true,
    supportCreatedAsV2: true,
    notSupportAdditionalColumns: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    isTableRequired: true,
    category: ['ServicesApps'],
    v2CopySourceControls: [
        {
            type: 'o365-scope-selection',
            parameterizable: true
        },
        {
            type: 'o365-query'
        }
    ]
};
